/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { socialGetSocialBilibiliUserinfo } from "../../funcs/socialGetSocialBilibiliUserinfo.js";
import { GetSocialBilibiliUserinfoRequest$zodSchema } from "../../models/getsocialbilibiliuserinfoop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetSocialBilibiliUserinfoRequest$zodSchema,
};

export const tool$socialGetSocialBilibiliUserinfo: ToolDefinition<typeof args> =
  {
    name: "social-get-social-bilibili-userinfo",
    description: `查询 B站用户

想在你的应用里集成B站用户资料展示？这个接口可以轻松获取用户的公开信息。

## 功能概述
通过一个用户的UID（那一串纯数字ID），你可以查询到该用户的昵称、性别、头像、等级、签名等一系列公开的基本信息。`,
    scopes: ["read"],
    annotations: {
      "title": "",
      "destructiveHint": false,
      "idempotentHint": false,
      "openWorldHint": true,
      "readOnlyHint": true,
    },
    args,
    tool: async (client, args, ctx) => {
      const [result] = await socialGetSocialBilibiliUserinfo(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      return formatResult(result.value);
    },
  };
